//css
import './app.css';
//js
import React, { useContext } from 'react';
import { Route, withRouter, Switch } from "react-router-dom";
import { StateContext } from 'context';
import { SnackbarProvider } from 'notistack';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import "moment/locale/es";
/* componentes */
import { Loading } from 'components/w3';
/* páginas */
import { Main } from 'app/main';
// import { AutorizacionDebito } from 'app/autorizacion-debito';
import Main2 from './main/main2';

const App = props => {
    const state = useContext(StateContext);
    // const [toasts, setToasts] = useState([]);
    const notistackRef = React.createRef();
    const onClickDismiss = key => () => {
        notistackRef.current.closeSnackbar(key);
    }
    return (
        <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            ref={notistackRef}
            action={(key) => (
                <IconButton aria-label="cerrar" onClick={onClickDismiss(key)}>
                    <FontAwesomeIcon icon={faTimes} color={'#ffffff'} size="xs" />
                </IconButton>
            )}>
            <>
                {state.appReducer.loading ? <Loading fondo='rgba(0,0,0,0.2)' /> : ''}
                <Switch>
                    <Route exact path="/" render={(props) => <Main {...props} />} />
                    <Route exact path="/destino/:id" render={(props) => <Main2 {...props} />} />
                    {/* <Route exact path="/autorizacion-de-debito" render={(props) => <AutorizacionDebito {...props} />} /> */}
                </Switch>
            </>
        </SnackbarProvider>
    );
}
export default withRouter(App);